/* eslint-disable */
import session from './session';

export default {
    getLocationsStatistic() {
        return session.get(`statistic/locations`);
    },
    getEmployeesStatistic() {
        return session.get(`statistic/employees`);
    },
    getPrepaidAccountsStatistic() {
        return session.get(`statistic/prepaid_accounts`);
    },
    getAppCustomerStatistic() {
        return session.get(`statistic/customers`);
    },
    getLockersStatistic() {
        return session.get(`statistic/lockers`);
    },
    getStorageParcelsStatistic() {
        return session.get(`statistic/storage`);
    },
    getExpectedParcelsStatistic() {
        return session.get(`statistic/expected`);
    },
    getOccupancyStatistic(days = 30, organization = null) {
        let url = `statistic/occupancy?days=${days}`;
        if (organization && organization !== "all") {
            url += `&organization=${organization}`;
        }
        return session.get(url);
    },
    getControlUnitsStatistic() {
        return session.get(`statistic/control_units/`);
    },
    getDashboardStatistic(organization = null) {
        let url = `statistic/dashboard`;
        if (organization && organization !== "all") {
            url += `?organization=${organization}`;
        }
        return session.get(url);
    },
};
